import AirtableTable from "../AirtableTable";
import { ArtistAmbassadorEvent } from "../models";
import { airtableFields, airtableTables } from "../schema";

export const artistAmbassadorEventFieldIds = airtableFields.artistAmbassadorEvents;

export class ArtistAmbassadorEventTable extends AirtableTable<ArtistAmbassadorEvent> {
  constructor(instance: any) {
    super(instance, airtableTables.artistAmbassadorEvents);

    this.fields = [
      artistAmbassadorEventFieldIds.artist,
      artistAmbassadorEventFieldIds.dateTime,
      artistAmbassadorEventFieldIds.numRegistrations,
    ];
  }

  getUpcoming = () => {
    return this.list({ sort: [{ field: artistAmbassadorEventFieldIds.dateTime, direction: "asc" }] })
      .then((items: any[]) => items.filter((item) =>
        new Date(item[artistAmbassadorEventFieldIds.dateTime]) > new Date()));
  };
}
